var filter = (function () {
  var serverImgUrl = function (imgSrc, cropSize, type) {
    var type = type == 'avatar' ? 'avatar' : 'images'
    if (!imgSrc) {
      return ''
    }
    var cropSizeStr = ''
    if (cropSize) {
      cropSizeStr = '_' + cropSize.split('x')[0]
    }
    var urlPointIndex = imgSrc.lastIndexOf('.')
    var urlArr = [imgSrc.substr(0, urlPointIndex), imgSrc.substr(urlPointIndex)]
    var urlBefore = ''

    // if(imgSrc.indexOf('http')!==0){
    //     // urlBefore='/upload/'+type+'/';
    //     urlBefore = imgSrc.startsWith('/upload/')
    //       ? 'https://' + window.EEOENV.upload.ugcfile
    //       : imgSrc.startsWith('/')
    //         ? 'https://' + window.EEOENV.upload.ugcfile + '/upload/'+type
    //         : 'https://' + window.EEOENV.upload.ugcfile + '/upload/'+type+'/';
    // }

    if (imgSrc.indexOf('http') !== 0) {
      if (imgSrc.includes('files/materiallib/course')) {
        urlBefore = `//${window.EEOENV.hosts.download}${imgSrc.startsWith('/') ? '' : '/'}`
      } else {
        if (imgSrc.includes('1F_00_')) {
          urlBefore = '//' + window.EEOENV.hosts.download + '/files/materiallib/course/'
        } else {
          urlBefore = '//' + window.EEOENV.hosts.download
        }
      }
      // ===imgSrc=== /files/materiallib/course/20220323/55409c754f20cc542833.jpeg!300
      console.log('===imgSrc===', imgSrc)
      // ===urlBefore=== //static14.eeo.im
      console.log('===urlBefore===', urlBefore)
    } else {
      console.warn('serverImgUrl_filter:some image url string has http head', imgSrc)
    }
    if (cropSizeStr !== '' && urlArr[0].lastIndexOf(cropSizeStr) === urlArr[0].length - cropSizeStr.length) {
      cropSizeStr = ''
      console.warn('serverImgUrl_filter:some image url string has crop info', imgSrc)
    }

    const ret = urlBefore + urlArr[0] + cropSizeStr + urlArr[1]
    console.log('===urlArr[0]===', urlArr[0], urlArr[1])
    console.log('===cropSizeStr===', cropSizeStr)
    console.log('===ret===', ret)
    return ret
  }
  return serverImgUrl
})()

export default filter
